<header class="app-header">
  <div class="breadcrumbs-container container">
    <div>
      <app-breadcrumbs></app-breadcrumbs>
      <div class="app-pageTitle">{{ $title.getTitle() | translate }}</div>
    </div>
  </div>
  <app-account-menu></app-account-menu>
</header>
<main>
  <div class="container">
    <app-loader-widget></app-loader-widget>
    <router-outlet></router-outlet>
  </div>
</main>
@if (window.innerWidth < 768) {
  <nav class="navMobile">
    <ul class="navMobile-iconList">
      <li (click)="navigateTo('profile')">
        <app-icon-account></app-icon-account>
      </li>
      <li (click)="navigateTo('answer')">
        <app-icon-answer></app-icon-answer>
      </li>
      <li (click)="navigateTo('favorite-form')">
        <app-icon-favorite></app-icon-favorite>
      </li>
      <li (click)="navigateTo('draft')">
        <app-icon-draft></app-icon-draft>
      </li>
      <li (click)="navigateTo('logout')">
        <app-icon-logout></app-icon-logout>
      </li>
    </ul>
  </nav>
}
